import React, { useState } from "react";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import Paper from "@mui/material/Paper";
import moment from "moment";
import SiteAdminThreeVerticalDots from "./SiteAdminThreeVerticalDots";
import { bytesToSize } from "../../../utils/utils";
import EmptyMessage from "../../slidebox/components/SlideTable/EmptyMessage";
import Loader from "../../slidebox/components/SlideTable/Loader";
import { useDateFormat } from "../../adminDashboard/components/DashboardItems/useFormat";

const SiteAdministratorDashboardTable = ({
  dxAccountDetails,
  showLoader,
  resendInvitation,
  updateLicenseType,
}) => {
  const [selectedRowIndex, setSelectedRowIndex] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);

  return showLoader ? (
    <Loader />
  ) : dxAccountDetails.length > 0 ? (
    <TableContainer className="table-scroll" elevation={0} component={Paper}>
      <Table sx={{ minWidth: 650, width: "100%" }} aria-label="simple table">
        <TableHead>
          <TableRow className="table-padding">
            <TableCell align="center">Account ID</TableCell>
            <TableCell align="center">Admin Email</TableCell>
            {/* <TableCell align="center">License Type</TableCell> */}
            <TableCell align="center">License Number</TableCell>
            <TableCell align="center">License start date</TableCell>
            <TableCell align="center">License end date</TableCell>
            <TableCell align="center">User Limit</TableCell>
            <TableCell align="center">Number of active users</TableCell>
            <TableCell align="center">Storage Used</TableCell>
            <TableCell align="center">Storage Limit</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {dxAccountDetails &&
            dxAccountDetails.length > 0 &&
            dxAccountDetails.map((details, index) => {
              return (
                <TableRow key={index}>
                  <TableCell>{details.dx_account_id}</TableCell>
                  <TableCell align="center">{details.admin_email_id}</TableCell>
                  {/* <TableCell align="center">{""}</TableCell> */}
                  <TableCell align="center" className="role-capitalize">
                    {details.license_number}
                  </TableCell>
                  <TableCell align="center">
                    {useDateFormat({ date: details.license_start_date })}
                  </TableCell>
                  <TableCell align="center">
                    {useDateFormat({ date: details.license_end_date })}
                  </TableCell>
                  <TableCell align="center" className="role-capitalize">
                    {details.userLimit}
                  </TableCell>
                  <TableCell align="center" className="role-capitalize">
                    {details.activeUsers[0].numberOfActiveUsers}
                  </TableCell>
                  <TableCell align="center" className="role-capitalize">
                    {bytesToSize(details.storage_used)}
                  </TableCell>
                  <TableCell align="center" className="role-capitalize">
                    {bytesToSize(details.storage_limit)}
                  </TableCell>
                  <SiteAdminThreeVerticalDots
                    selectedRowIndex={selectedRowIndex}
                    anchorEl={anchorEl}
                    setSelectedRowIndex={setSelectedRowIndex}
                    index={index}
                    resendInvitation={resendInvitation}
                    updateLicenseType={updateLicenseType}
                    details={details}
                  />
                </TableRow>
              );
            })}
        </TableBody>
      </Table>
    </TableContainer>
  ) : (
    <EmptyMessage mainMessage="No data found" />
  );
};

export default SiteAdministratorDashboardTable;
